/** @format */

export const PLANNING_DEFAULT_START = '07:30';

export const COLORS = [
  { bg: '#CECBF6', t: '#26215C', av: '#534AB7', at: '#EEEDFE' },
  { bg: '#9FE1CB', t: '#04342C', av: '#1D9E75', at: '#fff' },
  { bg: '#F5C4B3', t: '#4A1B0C', av: '#D85A30', at: '#fff' },
  { bg: '#B5D4F4', t: '#042C53', av: '#185FA5', at: '#fff' },
  { bg: '#F4C0D1', t: '#4B1528', av: '#D4537E', at: '#fff' },
  { bg: '#C0DD97', t: '#173404', av: '#3B6D11', at: '#fff' },
];

/** Visible day length. The window slides with the week's start hour. */
export const DAY_MIN = 10 * 60;

const planningDayWindow = { start: 7 * 60 };

export function getDayS() {
  return planningDayWindow.start;
}

export function getDayE() {
  return planningDayWindow.start + DAY_MIN;
}

/** Move the day cell so it runs [start, start + 10h]. */
export function setPlanningDayWindow(startMin) {
  const start = Number(startMin);
  if (!Number.isFinite(start)) return;
  const maxStart = 24 * 60 - DAY_MIN;
  planningDayWindow.start = Math.max(0, Math.min(Math.round(start), maxStart));
}
export const PAD = 4;
export const ROW_H = 165;
export const INNER = ROW_H - PAD * 2; // 157

export function technicianRowMetrics(expanded) {
  const rowH = expanded ? ROW_H * 2 : ROW_H;
  return { rowH, inner: rowH - PAD * 2 };
}
export const DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];
export const SNAP = 15; // minutes
/** Trip groups cannot be shorter than this (API `validate_trip_payload`). */
export const MIN_TRIP_GROUP_HOURS = 0.5;
export const WORKDAY = 420; // 7h
export const MAX_DAY = 9 * 60; // 9h max per day incl trajet
export const WEEK_TARGET = 35 * 60; // 35h
export const WEEK_MAX = 42 * 60; // 42h

export const ADDR_DEF = '400 rue Maurice Béjart, 34000 Montpellier';

/** Libow planning depot (driving-time origin for chantier rows). */
export const PLANNING_DEPOT_ADDRESS =
  '400 rue Maurice Béjart, 34080 Montpellier';
export const PLANNING_DEPOT_COORDS = { lat: 43.6083, lon: 3.9184 };

export const PROFIL_LABELS = {
  retraite: 'Généralement disponible',
  teletravail: 'Doit demander du télétravail',
  rdv: 'Sur RDV uniquement',
  facile: 'Facilement disponible',
};

export const PROFIL_COLORS = {
  retraite: { bg: '#DCFCE7', t: '#166534' },
  teletravail: { bg: '#FEF3C7', t: '#92400E' },
  rdv: { bg: '#FEE2E2', t: '#991B1B' },
  facile: { bg: '#DBEAFE', t: '#1E40AF' },
};

export const COORDS = {
  Montpellier: { lat: 43.61, lon: 3.88 },
  Agde: { lat: 43.31, lon: 3.47 },
  Castelnau: { lat: 43.64, lon: 3.9 },
  Juvignac: { lat: 43.62, lon: 3.82 },
  Beziers: { lat: 43.34, lon: 3.22 },
  Clermont: { lat: 43.63, lon: 3.43 },
  StJean: { lat: 43.58, lon: 3.83 },
  Bouzigues: { lat: 43.47, lon: 3.67 },
  Baillargues: { lat: 43.66, lon: 3.96 },
  Mauguio: { lat: 43.61, lon: 4.0 },
  Frontignan: { lat: 43.45, lon: 3.76 },
  Assas: { lat: 43.7, lon: 3.89 },
  Caux: { lat: 43.5, lon: 3.35 },
  Lattes: { lat: 43.57, lon: 3.9 },
  Castries: { lat: 43.67, lon: 3.97 },
  Claret: { lat: 43.74, lon: 3.9 },
  Balaruc: { lat: 43.45, lon: 3.68 },
  Nimes: { lat: 43.84, lon: 4.36 },
  LesAngles: { lat: 43.85, lon: 4.37 },
  Bouillargues: { lat: 43.78, lon: 4.39 },
  Marguerittes: { lat: 43.85, lon: 4.43 },
  LaCalmette: { lat: 43.92, lon: 4.22 },
  Caveirac: { lat: 43.78, lon: 4.3 },
  Beaucaire: { lat: 43.81, lon: 4.64 },
  Remoulins: { lat: 43.94, lon: 4.57 },
  Uzes: { lat: 44.01, lon: 4.42 },
  Milhaud: { lat: 43.78, lon: 4.33 },
  Aubord: { lat: 43.77, lon: 4.39 },
  Roquemaure: { lat: 44.05, lon: 4.76 },
  Ales: { lat: 44.13, lon: 4.08 },
  Sommieres: { lat: 43.78, lon: 4.09 },
};

export const TRUCK_SVG = `<svg width="13" height="9" viewBox="0 0 14 10" fill="none" style="flex-shrink:0;opacity:.5"><rect x="0" y="2" width="9" height="6" rx="1" fill="#888780"/><path d="M9 4h3l1.5 2.5V8h-4.5V4z" fill="#888780"/><circle cx="2.5" cy="9" r="1" fill="#5f5e5a"/><circle cx="11" cy="9" r="1" fill="#5f5e5a"/></svg>`;
